import { render, staticRenderFns } from "./EditUnderWritingQuestion.vue?vue&type=template&id=0fac4418"
import script from "./EditUnderWritingQuestion.vue?vue&type=script&lang=ts"
export * from "./EditUnderWritingQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports